import t from 'react-translate';
import { css } from '@emotion/react';
import { gray2, white } from 'styles/global_defaults/colors';
import { halfSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { screenMdMin, screenSmMin } from 'styles/global_defaults/media-queries';

import NvIcon from 'shared/components/nv-icon';
import ClickableContainer from 'components/clickable-container';
import { config } from '@config/pendo.config.json';

const ARROW_OFFSET_DESKTOP = 120;

const styles = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;

  i {
    color: ${white} !important;
  }

  &.carousel-left-arrow {
    left: ${ARROW_OFFSET_DESKTOP}px;
  }

  &.carousel-right-arrow {
    right: ${ARROW_OFFSET_DESKTOP}px;
  }

  @media (max-width: ${screenMdMin}px) {
    z-index: 2041;
    background-color: ${gray2};
    padding: ${halfSpacing}px;
    &.carousel-left-arrow {
      left: ${standardSpacing}px;
    }
    &.carousel-right-arrow {
      right: ${standardSpacing}px;
    }
  }
  @media (max-width: ${screenSmMin}px) {
    &.carousel-left-arrow {
      left: 0px;
    }
    &.carousel-right-arrow {
      right: 0px;
    }
  }
`;

const ICONS = {
  left: 'arrow-left',
  right: 'arrow-right',
};

const QA_TAG = {
  left: 'previousButton',
  right: 'nextButton',
};

const ARIA_LABEL = {
  left: 'PREVIOUS_BUTTON',
  right: 'NEXT_BUTTON',
}

type CarouselArrowProps = {
  direction: 'left' | 'right';
  onClick?: () => void;
};

const CarouselArrow = ({ direction, onClick }: CarouselArrowProps) => (
  <ClickableContainer
    className={`carousel-arrow carousel-${direction}-arrow`}
    css={styles}
    onClick={onClick}
    data-qa={
      config.pendo.athena.mentorshipProgram.participantHome.mentorRequest.modal
        .carousel[QA_TAG[direction]]
    }
    aria-label={t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.ARIA_LABEL.CAROUSEL[
      ARIA_LABEL[direction]
    ]()}
  >
    <NvIcon icon={ICONS[direction]} size='small' />
  </ClickableContainer>
);

export default CarouselArrow;
